import React from "react";
import styled from 'styled-components';

const Root = styled.div`
background-position:left;
background-size:100% 100%;
background-repeat:no-repeat;
border-radius:${(p) => p.theme.radius.md};
width:calc(50% - 20px);
display:flex;
align-items:center;
background-color: #151a1c;
padding: 15px 20px;
@media(max-width:${(p) => p.theme.screen.xs}){
   width:100%;
   margin-bottom:${(p) => p.theme.spacing.sm};
}
`;
const Images = styled.img`
width:24px;

`;
const InfoWrapper = styled.div`

`;
const Title = styled.div`
   font-size: 16px;
   color: #787878;
   font-weight: 500;
`;
const Number = styled.div`
letter-spacing: 0.62px;
font-size:${(p) => p.theme.font.size.lg};
font-weight:${(p) => p.theme.font.weight.bold};
padding-top: 10px;
@media(max-width:768px){
   font-size:24px;
}
`;
const IconWrapper = styled.div`
  width:40px;
  height:40px;
  min-width:40px;
  min-height:40px; 
  background-color:#1c3741;
  display:flex;
  border-radius:50%;
  align-items:center;
  justify-content:center;
  margin-right:${(p) => p.theme.spacing.sm};
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;
  :hover, :focus, :active {
   -webkit-transform: scale(1.2);
   transform: scale(1.2);
   }
`;
const SocialMediaInfoCard = ({ text, Icon, number, color1, color2, color3, color4 }) => {
   return (
      <Root color1={color1} color2={color2} color3={color3} color4={color4}>
         <IconWrapper><Images src={Icon} alt={Icon} /></IconWrapper>
         <InfoWrapper>
            <Title>
               {text}
            </Title>
            <Number>
               {number}
            </Number>
         </InfoWrapper>
      </Root>
   );
};

export default SocialMediaInfoCard;